module.exports = __webpack_public_path__ + "img/工作區域 7.png";